// src/utilities/version.js
// Update this string manually each time a release is cut.
// It must exactly match the version submitted to SongStack.
export const APP_VERSION = '1.2.12';
export const APP_VERSION_DATE = '2026-06-24';
export const HYMNFORGE_URL = 'https://songstack.getpartaker.com/hymnforge';

/**
 * Returns true when `available` is a higher semver than `current`.
 * Compares major, minor, patch numerically — never as strings.
 *
 * @param {string} available  Version from the API, e.g. "1.2.0"
 * @param {string} current    Hardcoded app version, e.g. "1.1.2"
 * @returns {boolean}
 */
export function isNewerVersion(available, current) {
    const a = available.split('.').map(Number);
    const c = current.split('.').map(Number);
    for (let i = 0; i < 3; i++) {
        if (a[i] > c[i]) return true;
        if (a[i] < c[i]) return false;
    }
    return false; // equal
}
